import { SAVE_USER_CONNECTED, LOGOUT_USER, FETCH_CART_SUCCESS } from './userActionTypes';

const initialState = {
    isLoggedIn: false,
    userConnected: {},
    cart: null,
};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case SAVE_USER_CONNECTED:
            return {
                ...state,
                isLoggedIn: true,
                userConnected: action.payload,
            };
        case LOGOUT_USER:
            return initialState;
        case FETCH_CART_SUCCESS:
            return {
                ...state,
                cart: action.payload,
            };
        default:
            return state;
    }
}


